(() => {
  const mq = window.matchMedia("(min-width: 990px) and (hover: hover) and (pointer: fine)");
  const SELECTOR = ".header__inline-menu > ul > li > header-menu details";

  function setup() {
    const detailsList = Array.from(document.querySelectorAll(SELECTOR));
    if (!detailsList.length) return;

    const closeAll = (except) => {
      detailsList.forEach(d => {
        if (d !== except) {
          d.removeAttribute("open");
          d.classList.remove("menu-opening");
        }
      });
    };

    detailsList.forEach(d => {
      d.addEventListener("mouseenter", () => {
        if (!mq.matches) return;
        closeAll(d);
        d.setAttribute("open", "");
        d.classList.add("menu-opening"); // some themes rely on this
      });

      d.addEventListener("mouseleave", () => {
        if (!mq.matches) return;
        d.removeAttribute("open");
        d.classList.remove("menu-opening");
      });

      // keyboard accessibility: open when tabbing in
      d.addEventListener("focusin", () => {
        if (!mq.matches) return;
        closeAll(d);
        d.setAttribute("open", "");
        d.classList.add("menu-opening");
      });

      d.addEventListener("focusout", (e) => {
        if (!mq.matches) return;
        if (!d.contains(e.relatedTarget)) {
          d.removeAttribute("open");
          d.classList.remove("menu-opening");
        }
      });
    });

    // click outside closes
    document.addEventListener("pointerdown", (e) => {
      if (!mq.matches) return;
      if (!e.target.closest(".header__inline-menu")) closeAll(null);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
  } else {
    setup();
  }

  mq.addEventListener?.("change", () => {
    // optional: close all on mode change
    document.querySelectorAll(SELECTOR).forEach(d => {
      d.removeAttribute("open");
      d.classList.remove("menu-opening");
    });
  });
})();
